import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayButton = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "url(#paint0_linear_68_1534)",
			style: { transition: "fill 0.2s" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7111 11.208L9.06192 6.10732C8.51744 5.78745 7.85718 6.22082 7.85718 6.90183V17.0997C7.85718 17.7807 8.51744 18.2141 9.06192 17.8908L17.7111 12.7936C18.2868 12.4531 18.2868 11.5485 17.7111 11.208Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_68_1534",
			x1: 12,
			y1: 0,
			x2: 12,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5690FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#3271E6"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgPlayButton);
export default ForwardRef;
